'use strict';

import template from '../../templates/users/User.ejs';

module.exports = Backbone.View.extend({
    tagName: 'tr',

    events() {
        return {
            'click .js-grant-admin': 'grantAdmin',
            'click .js-revoke-admin': 'revokeAdmin'
        };
    },

    initialize() {
        this.model.on('sync', this.render, this);
        return this.render();
    },

    render() {
        this.$el.html(template({model: this.model}));
        return this;
    },

    grantAdmin() {
        this.model.setRole('admin_manager');
    },

    revokeAdmin() {
        this.model.setRole('employer');
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/users/User.js